import { render, staticRenderFns } from "./edit-chip-dialog.vue?vue&type=template&id=1d909422&scoped=true&"
import script from "./edit-chip-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-chip-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d909422",
  null
  
)

export default component.exports